import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const AjaxTokenKey = 'ajaxtoken'
const TipsKey = 'tips'
const GoodsTableSelectCheckedKey = 'GoodsTableSelectChecked'
const SearchCategoryKey = 'SearchCategorys'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getAjaxToken() {
  return Cookies.get(AjaxTokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setAjaxToken(token) {
  return Cookies.set(AjaxTokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeAjaxToken() {
  return Cookies.remove(AjaxTokenKey)
}

export function getTips() {
  return Cookies.get(TipsKey)
  // return "admin-token"
}
export function getGoodsTableSelectChecked() {
  return Cookies.get(GoodsTableSelectCheckedKey)
}

export function setTips(day) {
  return Cookies.set(TipsKey, "over",{expires:day})
}
export function setGoodsTableSelectChecked(val) {
  return Cookies.set(GoodsTableSelectCheckedKey,val);
}
export function removeTips() {
  return Cookies.remove(TipsKey)
}

export function getSearchCategory() {
  return Cookies.get(SearchCategoryKey)
}

export function setSearchCategory(val) {
  return Cookies.set(SearchCategoryKey, val)
}

export function removeSearchCategory() {
  return Cookies.remove(SearchCategoryKey)
}
